import { readDraftText } from "@/features/oio/services/draft-storage.service"

/**
 * Fetch a finished draft's content from its GCS blob, for the terminal
 * (draft_completed/draft_filed/draft_failed_terminal) reconnect path — never
 * called for an in-progress thread, which goes through useDraftStreamReconnect
 * instead. See docs/superpowers/specs/2026-06-20-draft-stream-reconnect-design.md.
 *
 * artifact_blob_url is the single source of truth. No localStorage caching.
 */
export async function hydrateFinishedDraft(
  threadId: string,
  blobUrl: string | undefined,
): Promise<string | null> {
  if (!blobUrl) return null
  try {
    const content = await readDraftText(blobUrl)
    return content || null
  } catch {
    // non-fatal — live stream reconnect is the other recovery path
    return null
  }
}
